package com.exura.components.pageTypography

import androidx.compose.runtime.Composable
import com.exura.ui.Dimens
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.borderBottom
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.justifyContent
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.silk.style.ComponentKind
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.CssStyleVariant
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.palette.border
import com.varabyte.kobweb.silk.theme.colors.palette.toPalette
import org.jetbrains.compose.web.css.JustifyContent
import org.jetbrains.compose.web.css.LineStyle

@Composable
internal fun PageOptionsSection(
    modifier: Modifier = Modifier,
    variant: CssStyleVariant<OptionsSectionKind>? = null,
    controls: @Composable () -> Unit,
) {
    Row(
        modifier = OptionsSectionStyle.toModifier(variant).then(modifier),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(Dimens.pageHeaderNavControlsGap),
    ) {
        controls()
    }
}

sealed interface OptionsSectionKind : ComponentKind


val OptionsSectionStyle = CssStyle<OptionsSectionKind> {
    val palette = colorMode.toPalette()
    base {
        Modifier
            .fillMaxWidth()
            .justifyContent(JustifyContent.End)
            .padding(leftRight = Dimens.pageOptionsIndent, topBottom = Dimens.pageOptionsWrapping)
            .borderBottom(Dimens.pageOptionsSeparatorWidth, LineStyle.Solid, palette.border)
    }
}
